import { render } from "./UpdateDivisionPlanComponent.vue?vue&type=template&id=59c34901"
import script from "./UpdateDivisionPlanComponent.vue?vue&type=script&lang=js"
export * from "./UpdateDivisionPlanComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__